import { Moon, Phone } from "lucide-react";
import { PHONE, PHONE_HREF } from "@/data/site";

export const AfterHoursCallout = () => (
  <div data-testid="after-hours-callout" className="bg-white border-l-4 border-brand-red border-y border-r border-zinc-200 rounded-sm p-6 sm:p-8">
    <div className="flex items-start gap-4">
      <Moon className="w-8 h-8 text-brand-red shrink-0" />
      <div>
        <h3 className="font-heading font-bold text-xl text-brand-ink">24/7 Emergency Booking</h3>
        <p className="text-sm text-zinc-600 mt-2 leading-relaxed">
          Call any time — our system takes your request, and a technician is dispatched after a <span className="font-bold text-brand-ink">$200 prepaid emergency booking fee</span>, which is applied toward your repair.
        </p>
        <a href={PHONE_HREF} data-testid="after-hours-call-link"
          className="inline-flex items-center gap-2 mt-4 bg-brand-red hover:bg-[#B02222] text-white font-bold px-6 py-3 rounded-sm transition-colors duration-200 text-sm">
          <Phone className="w-4 h-4" /> Call {PHONE} — 24/7
        </a>
      </div>
    </div>
  </div>
);
